import { useEffect } from "react";
import "./ModalPreview.css"
import download from "../../assets/images/downloadFileIcon.svg"
import { useTranslationContext } from "../../contexts/TranslationContext";
import { downloadFile } from "../../utility/downloadFile";
import { toast } from "react-toastify";

function MediaPreview({ type, src, isOpen, onClose, loading, setLoading }) {

  const {translations} = useTranslationContext();
  const downloadText = translations["download_text"] || "Download";
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen || !src) return null;

  // Force download handler
  const handleDownload = (e) => {
    e.stopPropagation();
    downloadFile({
      url: src,
      filename: `preview-${Date.now()}.jpg`
    }).catch(() => {
      toast.error("Download failed. Please try again.");
    });
  };

  return (
    <div
      className="modal-overlay-files"
      onClick={onClose}
    >
      <div className="modal-content-files" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="close-btn" onClick={onClose}>
          ✖
        </button>

        {type === "video" && <video src={src} controls autoPlay />}

        {type === "image" && (
          <div className="image-preview-wrapper">
            {loading && <div className="spinner-loader"></div>}
            <img
              src={src}
              alt="preview"
              style={{ display: loading ? "none" : "block" }}
              onLoad={() => setLoading(false)}
              onError={() => setLoading(false)}
            />
            {(!loading &&
          
            <button
              className="download-btn-overlay"
              title={downloadText}
              onClick={handleDownload}
            >
              <img src={download} alt="download-icon"></img>
            </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default MediaPreview;
